"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @file Storage 本地存储
 * @author qiaogang
 * @date 2020-02-26
 */
var PREFIX = 'igc_h5_';
var Storage = {
  setItem: function setItem(key, value) {
    var valObj = {
      value: value
    };
    localStorage.setItem("".concat(PREFIX).concat(key), JSON.stringify(valObj));
  },
  getItem: function getItem(key) {
    var val = localStorage.getItem("".concat(PREFIX).concat(key));

    try {
      val = JSON.parse(val).value;
    } catch (e) {}

    return val;
  },
  removeItem: function removeItem(key) {
    localStorage.removeItem(key);
  },
  clear: function clear() {
    localStorage.clear();
  }
};
var _default = Storage;
exports["default"] = _default;